export enum EService {
  FIRST_SERVICE = 'FIRST_SERVICE',
  MINOR_SERVICE = 'MINOR_SERVICE',
  MAJOR_SERVICE = 'MAJOR_SERVICE',
}
